import styled from 'styled-components'
import media from '../../utils/media'

export const Container = styled.div`
  padding-top: 65px;
  padding-left: 70px;
  padding-right: 70px;

  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;

  line-height: 28px;
  color: #000;

  p {
    margin-bottom: 28px;
    ${media.lessThan('sm')`margin-bottom:22px; `};
  }

  ${media.lessThan('md')`
    -ms-flex-direction: column;
    flex-direction: column;
   
  `};

  ${media.greaterThan('md')`
    max-width: 1800px;
    -ms-flex-direction: row;
    flex-direction: row;
    & > * {
      padding-right: 40px;
      width: 25%;
    }
  `};

  ${media.lessThan('sm')`
    padding-left: 16px; 
    padding-right: 16px;
  `};

  ${media.greaterThan('1940px')`
    padding-left: calc((100% - 1800px) / 2);
  `};

  a {
    text-decoration: none;
    opacity: 0.4;
    color: #000;
  }

  div:nth-of-type(4),
  div:nth-of-type(8) {
    p {
      font-size: 10px;
      line-height: 15px;
      margin-bottom: 10px;
    }
  }

  br {
    opacity: 0;
  }
`
